function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "blur",
  width: "200%",
  height: "200%"
}, React.createElement("feGaussianBlur", {
  in: "SourceAlpha",
  stdDeviation: 3
}), React.createElement("feOffset", {
  dx: 0,
  dy: 4,
  result: "offsetblur"
}), React.createElement("feComponentTransfer", null, React.createElement("feFuncA", {
  type: "linear",
  slope: 0.05
})), React.createElement("feMerge", null, React.createElement("feMergeNode", null), React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#blur)",
  id: "day"
}, React.createElement("g", {
  transform: "translate(32,32)"
}, React.createElement("g", {
  className: "am-weather-sun am-weather-sun-shiny am-weather-easing-ease-in-out"
}, React.createElement("g", null, React.createElement("line", {
  fill: "none",
  stroke: "orange",
  strokeLinecap: "round",
  strokeWidth: 2,
  transform: "translate(0,9)",
  x1: 0,
  x2: 0,
  y1: 0,
  y2: 3
})), React.createElement("g", {
  transform: "rotate(45)"
}, React.createElement("line", {
  fill: "none",
  stroke: "orange",
  strokeLinecap: "round",
  strokeWidth: 2,
  transform: "translate(0,9)",
  x1: 0,
  x2: 0,
  y1: 0,
  y2: 3
})), React.createElement("g", {
  transform: "rotate(90)"
}, React.createElement("line", {
  fill: "none",
  stroke: "orange",
  strokeLinecap: "round",
  strokeWidth: 2,
  transform: "translate(0,9)",
  x1: 0,
  x2: 0,
  y1: 0,
  y2: 3
})), React.createElement("g", {
  transform: "rotate(135)"
}, React.createElement("line", {
  fill: "none",
  stroke: "orange",
  strokeLinecap: "round",
  strokeWidth: 2,
  transform: "translate(0,9)",
  x1: 0,
  x2: 0,
  y1: 0,
  y2: 3
})), React.createElement("g", {
  transform: "rotate(180)"
}, React.createElement("line", {
  fill: "none",
  stroke: "orange",
  strokeLinecap: "round",
  strokeWidth: 2,
  transform: "translate(0,9)",
  x1: 0,
  x2: 0,
  y1: 0,
  y2: 3
})), React.createElement("g", {
  transform: "rotate(225)"
}, React.createElement("line", {
  fill: "none",
  stroke: "orange",
  strokeLinecap: "round",
  strokeWidth: 2,
  transform: "translate(0,9)",
  x1: 0,
  x2: 0,
  y1: 0,
  y2: 3
})), React.createElement("g", {
  transform: "rotate(270)"
}, React.createElement("line", {
  fill: "none",
  stroke: "orange",
  strokeLinecap: "round",
  strokeWidth: 2,
  transform: "translate(0,9)",
  x1: 0,
  x2: 0,
  y1: 0,
  y2: 3
})), React.createElement("g", {
  transform: "rotate(315)"
}, React.createElement("line", {
  fill: "none",
  stroke: "orange",
  strokeLinecap: "round",
  strokeWidth: 2,
  transform: "translate(0,9)",
  x1: 0,
  x2: 0,
  y1: 0,
  y2: 3
}))), React.createElement("circle", {
  cx: 0,
  cy: 0,
  fill: "orange",
  r: 5,
  stroke: "orange",
  strokeWidth: 2
})));

var SvgSw = function SvgSw(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 70,
    viewBox: "17 17 30 30",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSw, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sw.b7730521.svg";
export { ForwardRef as ReactComponent };